import { Card, CardContent, CardMedia, Stack, Typography } from "@mui/material";
import { Helmet } from "react-helmet-async";

const youtubeList = [
  {
    title : '정규식 사이트 기본 사용법',
    src : 'https://www.youtube.com/embed/faV_059chkM?si=UwNxbo_uR5Mm4M5b'
  },
  {
    title : '제외할 맵모드 생성 방법',
    src : 'https://www.youtube.com/embed/TsH21ScBts8?si=eQbwLpwsIkAosXjp'
  },
  {
    title : '정규식 한영변환, tft 8모드 구매 가이드',
    src : 'https://www.youtube.com/embed/H75yOdH17OY?si=cT9dN3HC0Ql8-yXW'
  },
]

function Guide() {
  return (
    <>
      <Helmet>
        <title>사이트 이용 가이드</title>
        <meta
          name="description"
          content="패스 오브 엑자일(POE) 정규식 사이트 이용 가이드. 정규식 사이트 기본 사용법, 제외할 맵모드 생성 방법, 정규식 한영변환 및 TFT 8모드 구매 가이드 영상을 제공합니다."
        />
        <meta property="og:title" content="사이트 이용 가이드 - POE Regex KR" />
        <meta property="og:description" content="패스 오브 엑자일(POE) 정규식 사이트 이용 가이드. 정규식 사이트 기본 사용법, 제외할 맵모드 생성 방법, 한영변환 가이드 영상을 제공합니다." />
        <meta property="og:url" content="https://poeregexkr.web.app/guide" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://poeregexkr.web.app/mirror.png" />
      </Helmet>
      <Typography variant="h5" sx={{ fontWeight: 700, mb: 2 }}>
        이용 가이드
      </Typography>
      <Stack spacing={2.5}>
        {youtubeList.map((data, i) => (
          <Card key={i}>
            <CardMedia
              component="iframe"
              title={data.title}
              src={data.src}
              sx={{ aspectRatio: 16 / 9, border: 0 }}
              frameBorder="0"
              allowFullScreen
            />
            <CardContent sx={{ borderTop: '1px solid', borderColor: 'divider', textAlign: 'center' }}>
              <Typography sx={{ fontWeight: 600 }}>
                {data.title}
              </Typography>
            </CardContent>
          </Card>
        ))}
      </Stack>
    </>
  )
}

export default Guide;
